import LahoreAntique from "../../images/LahoreAntique.jpg";
import LahoreAntiqueWithControl from "../../images/LahoreAntiqueWithControl.png";
import LahoreModel from "../../images/LahoreModel.jpg";
import LahoreModelWithControl from "../../images/LahoreModelWithControl.png";
import MagnumWhite from "../../images/MagnumWhite.jpg";
import MagnumWhiteWithControl from "../../images/MagnumWhiteWithControl.png";
import MagnumDesignWithControl from "../../images/MagnumDesignWithControl.png";
import MagnumBlackDesignWithControl from "../../images/MagnumBlackDesignWithControl.png";
import NineStar from "../../images/NineStar.jpg";
import NineStarWithControl from "../../images/NineStarWithControl.png";
import TwoDownAntiqueGoldenWithControl from "../../images/TwoDownAntiqueGoldenWithControl.png";
import TwoDownAntiqueBlack from "../../images/TwoDownAntiqueBlack.jpg";
import TwoDownAntiqueBlackWithControl from "../../images/TwoDownAntiqueBlackWithControl.png";

export const ProductsList = [
    {
        id:"lahore-antique",
        name: "Lahore Antique",
        image: LahoreAntique,
        description: "High-quality and eco-friendly product.",
        price: "Rs. 9,195.00",
        series: "AC / DC INVERTER SERIES",
        path: "/product-details",
        colors: [{name:"Black", image: LahoreAntiqueWithControl}],
        sizes: ["56”/COPPER"]
    },
    {
        id:"lahore-model",
        name: "Lahore Model",
        image: LahoreModel,
        description: "High-quality and eco-friendly product.",
        price: "Rs. 9,195.00",
        series: "AC / DC INVERTER SERIES",
        path: "/product-details",
        colors: [{name:"Off-White", image: LahoreModelWithControl}],
        sizes: ["56”/COPPER"]

    },
    {
        id:"magnum",
        name: "Magnum",
        image: MagnumWhite,
        description: "High-quality and eco-friendly product.",
        price: "Rs. 9,195.00",
        series: "AC / DC INVERTER SERIES",
        path: "/product-details",
        colors: [
            {name:"White", image: MagnumWhiteWithControl},
            { name: "Off-White", image: MagnumDesignWithControl },
            { name: "Black", image: MagnumBlackDesignWithControl },
        ],
        sizes: ["56”/COPPER"]
    },
    {
        id:"nine-star",
        name: "Nine Star",
        image: NineStar,
        description: "High-quality and eco-friendly product.",
        price: "Rs. 9,195.00",
        series: "AC / DC INVERTER SERIES",
        path: "/product-details",
        colors: [{name:"Off-White", image: NineStarWithControl}],
        sizes: ["56”/COPPER"]
    },
    {
        id:"two-down-antique",
        name: "Two Down Antique",
        image: TwoDownAntiqueBlack,
        description: "High-quality and eco-friendly product.",
        price: "Rs. 9,195.00",
        series: "AC / DC INVERTER SERIES",
        path: "/product-details",
        colors: [{ name: "Black(Golden Cup)", image: TwoDownAntiqueGoldenWithControl }, { name: "Black(Black Cup)", image: TwoDownAntiqueBlackWithControl }],
        sizes: ["56”/COPPER"]
    },
];